<template>
  <div id="app">
    <el-container>
      <el-header class="site-header" :class="{ 'site-header--admin': isAdminRoute }">
        <div class="site-header__inner">
          <router-link class="brand" to="/">
            <span class="brand__logo">
              <img src="./assets/img/yufei-logo-transparent.png" alt="宇飞智能" />
            </span>
            <span class="brand__text">
              <strong>{{ site.company.shortName }}</strong>
              <small>智慧通行云平台</small>
            </span>
          </router-link>

          <el-menu
            :default-active="defaultActive"
            class="site-nav"
            mode="horizontal"
            :router="true"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/product">产品中心</el-menu-item>
            <el-menu-item index="/case">经典案例</el-menu-item>
            <el-menu-item index="/news">新闻资讯</el-menu-item>
            <el-menu-item index="/goin">走进宇飞</el-menu-item>
          </el-menu>

          <router-link class="header-cta" to="/product">查看方案</router-link>
        </div>
      </el-header>

      <el-main>
        <router-view />
      </el-main>

      <footer v-if="!isAdminRoute" class="site-footer">
        <div class="footer-glow"></div>
        <div class="site-footer__inner">
          <div class="footer-brand">
            <div class="brand brand--footer">
              <span class="brand__logo brand__logo--footer">
                <img src="./assets/img/yufei-logo-footer.png" alt="宇飞智能" />
              </span>
              <span class="brand__text">
                <strong>{{ site.company.name }}</strong>
                <small>{{ site.company.slogan }}</small>
              </span>
            </div>
            <p>{{ site.company.description }}</p>
          </div>

          <div class="footer-links">
            <h4>快速导航</h4>
            <router-link to="/product">产品中心</router-link>
            <router-link to="/case">经典案例</router-link>
            <router-link to="/goin">关于我们</router-link>
          </div>

          <div class="footer-contact">
            <h4>联系我们</h4>
            <p>邮箱：{{ site.company.email }}</p>
            <p>电话：{{ site.company.phone }}</p>
            <p>地址：{{ site.company.address }}</p>
          </div>
        </div>
        <div class="copyright">
          <span>@2021 Yufei Intelligent Technology Co., Ltd.</span>
          <a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener">{{ site.company.icp }}</a>
        </div>
      </footer>
    </el-container>
  </div>
</template>

<script>
import site from "./static/siteData";

export default {
  data() {
    return {
      site
    };
  },
  computed: {
    defaultActive() {
      const path = this.$route.path;
      if (path.indexOf("/news") === 0) return "/news";
      if (path.indexOf("/case") === 0) return "/case";
      if (path.indexOf("/product") === 0) return "/product";
      if (path.indexOf("/goin") === 0) return "/goin";
      return "/";
    },
    isAdminRoute() {
      return this.$route.path.indexOf("/admin") === 0 || this.$route.path.indexOf("/login") === 0;
    }
  }
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

html,
body {
  min-height: 100%;
  background: #f4f8ff;
}

body {
  color: #102033;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
}

a {
  color: inherit;
  text-decoration: none;
}

#app {
  min-height: 100vh;
  color: #102033;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.el-container {
  min-height: 100vh;
}

.site-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 72px !important;
  padding: 0 !important;
  border-bottom: 1px solid rgba(22, 119, 255, 0.12);
  background: rgba(255, 255, 255, 0.84);
  backdrop-filter: blur(18px);
  box-shadow: 0 18px 50px rgba(22, 72, 145, 0.08);
}

.site-header--admin {
  position: relative;
}

.site-header__inner {
  width: min(1200px, calc(100% - 40px));
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}

.brand__logo {
  width: 220px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: transparent;
}

.brand__logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.brand__logo--footer {
  width: 210px;
  height: 40px;
  filter: drop-shadow(0 0 12px rgba(255, 255, 255, 0.14));
}

.brand__text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.brand__text strong {
  font-size: 17px;
  color: #071a35;
}

.brand__text small {
  margin-top: 3px;
  color: #667892;
  font-size: 12px;
}

.site-nav {
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  border-bottom: 0 !important;
  background: transparent !important;
}

.site-nav.el-menu--horizontal > .el-menu-item {
  height: 72px;
  line-height: 72px;
  border-bottom: 0 !important;
  color: #314563;
  font-size: 15px;
  padding: 0 18px;
}

.site-nav.el-menu--horizontal > .el-menu-item.is-active,
.site-nav.el-menu--horizontal > .el-menu-item:hover {
  color: #1677ff;
  background: transparent;
}

.site-nav.el-menu--horizontal > .el-menu-item.is-active::after {
  content: "";
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: 16px;
  height: 3px;
  border-radius: 99px;
  background: linear-gradient(90deg, #1677ff, #00d4ff);
}

.header-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  padding: 0 18px;
  border-radius: 99px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  background: linear-gradient(135deg, #1677ff, #05c8ff);
  box-shadow: 0 12px 30px rgba(22, 119, 255, 0.26);
}

.el-main {
  padding: 0 !important;
}

.site-footer {
  position: relative;
  overflow: hidden;
  color: #dfeaff;
  background:
    linear-gradient(135deg, rgba(5, 18, 45, 0.96), rgba(8, 42, 92, 0.98)),
    radial-gradient(circle at 75% 0%, rgba(22, 119, 255, 0.35), transparent 34%);
}

.footer-glow {
  position: absolute;
  inset: auto -10% -40% 45%;
  height: 260px;
  background: radial-gradient(circle, rgba(0, 210, 255, 0.22), transparent 62%);
  pointer-events: none;
}

.site-footer__inner {
  position: relative;
  width: min(1200px, calc(100% - 40px));
  margin: 0 auto;
  padding: 54px 0 42px;
  display: grid;
  grid-template-columns: 1.5fr 0.7fr 1fr;
  gap: 42px;
}

.brand--footer .brand__text strong,
.site-footer h4 {
  color: #fff;
}

.brand--footer .brand__text small,
.site-footer p,
.site-footer a {
  color: #aebfda;
}

.footer-brand p {
  max-width: 520px;
  margin-top: 18px;
  line-height: 1.8;
  font-size: 14px;
}

.footer-links,
.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.site-footer h4 {
  margin-bottom: 6px;
  font-size: 17px;
}

.footer-contact p {
  line-height: 1.7;
  font-size: 14px;
}

.copyright {
  position: relative;
  width: min(1200px, calc(100% - 40px));
  margin: 0 auto;
  padding: 18px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  justify-content: space-between;
  gap: 16px;
  color: #8fa4c4;
  font-size: 13px;
}

.page-shell {
  background: #f4f8ff;
}

.section-wrap {
  width: min(1200px, calc(100% - 40px));
  margin: 0 auto;
}

.section-kicker {
  color: #1677ff;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0;
}

.section-title {
  margin-top: 10px;
  color: #071a35;
  font-size: 34px;
  line-height: 1.25;
  font-weight: 800;
}

.section-desc {
  margin-top: 14px;
  color: #62728a;
  font-size: 16px;
  line-height: 1.8;
}

@media (max-width: 900px) {
  .site-header {
    height: auto !important;
  }

  .site-header__inner {
    width: min(100% - 24px, 720px);
    padding: 12px 0;
    flex-wrap: wrap;
    gap: 10px;
  }

  .site-nav {
    order: 3;
    width: 100%;
    justify-content: flex-start;
    overflow-x: auto;
  }

  .site-nav.el-menu--horizontal > .el-menu-item {
    height: 42px;
    line-height: 42px;
    padding: 0 12px;
    font-size: 14px;
  }

  .site-nav.el-menu--horizontal > .el-menu-item.is-active::after {
    bottom: 4px;
  }

  .brand__text strong {
    font-size: 16px;
  }

  .header-cta {
    height: 34px;
    padding: 0 14px;
  }

  .site-footer__inner {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .copyright {
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .section-wrap,
  .site-footer__inner,
  .copyright {
    width: calc(100% - 24px);
  }

  .brand__logo {
    width: 168px;
    height: 34px;
  }

  .section-title {
    font-size: 26px;
  }
}
</style>
